var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "crud-form-group",
      class: _vm.validationRules ? _vm.getValidationClass() : ""
    },
    [
      _vm.showLabel
        ? _c("CrudLabel", {
            attrs: {
              label: _vm.label,
              hasCheckBox: _vm.hasCheckBox,
              checkboxData: _vm.checkboxData,
              classList: _vm.classList
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "dropdown-container", attrs: { id: _vm.id } }, [
        _c(
          "div",
          {
            staticClass: "dropdown-activator",
            class: _vm.activatorClass,
            on: { click: _vm.toggleSelect }
          },
          [
            _c(
              "span",
              {
                staticClass: "select-label",
                class: !_vm.selectedOption ? "placeholder" : ""
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      !_vm.selectedOption
                        ? _vm.placeholder
                        : _vm.selectedOption.label
                    ) +
                    " "
                )
              ]
            ),
            _c("span", { ref: "dropArrow", staticClass: "arrow" }, [
              _c("img", {
                attrs: {
                  src: require("@/drc/assets/icons/arrow-down-white.svg"),
                  alt: "Dropdwon"
                }
              })
            ])
          ]
        ),
        _c("div", { staticClass: "options-container" }, [
          _c(
            "div",
            { ref: "optionContainer", staticClass: "dropdown-options" },
            _vm._l(_vm.optionsList, function(option, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "option no-check",
                  on: {
                    click: function($event) {
                      return _vm.selectOption(index)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "option-text" }, [
                    _vm._v(_vm._s(option.label))
                  ])
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm.errors.length
        ? _c("ErrorList", {
            attrs: { errors: _vm.errors, classList: _vm.errorsClassList }
          })
        : _vm._e(),
      _vm.parentErrors.length
        ? _c("ErrorList", {
            attrs: { errors: _vm.parentErrors, classList: _vm.errorsClassList }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }